export const CLASS_BODY_HIDDEN = 'body--hidden';
export const CLASS_MENU_VISIBLE = 'menu--visible';
export const CLASS_MENU = 'menu';
export const CLASS_MENU_BTN_CLOSE = 'menu-btn--close';
export const CLASS_MENU_BTN = 'menu-btn';
export const CLASS_LANGUAGE_SELECTOR = 'language-selector';
export const CLASS_LANGUAGE_SELECTOR_BUTTON = 'language-selector__button';
export const CLASS_LANGUAGE_SELECTOR_BUTTON_HIDDEN =
  'language-selector__button--hidden';
export const CLASS_LANGUAGE_SELECTOR_BUTTON_DROPDOWN_VISIBLE =
  'language-selector__button--dropdown-visible';
export const CLASS_LANGUAGE_SELECTOR_ITEM = 'language-selector__item';
export const CLASS_LANGUAGE_SELECTOR_DROPDOWN = 'language-selector__dropdown';
export const CLASS_LANGUAGE_SELECTOR_DROPDOWN_VISIBLE =
  'language-selector__dropdown--visible';
export const CLASS_HEADER_MAIN_PART = 'header__main-part';
export const CLASS_HEADER_MAIN_PART_HIDDEN = 'header__main-part--hidden';
export const CLASS_HEADER_BOTTOM_PART = 'header__bottom-part';
export const CLASS_HEADER_BOTTOM_PART_HIDDEN = 'header__bottom-part--hidden';
export const CLASS_HEADER = 'header';
export const CLASS_SCROLL_UP_BTN = 'scroll-up-btn';
export const CLASS_SCROLL_UP_BTN_VISIBLE = 'scroll-up-btn--visible';

export const DATA_TRANSLATE_MENU_OPEN = 'menuBtnOpen';
export const DATA_TRANSLATE_MENU_CLOSE = 'menuBtnClose';

export const ANIMATION_DURATION = 300;

export const LOCAL_STORAGE_LANGUAGE_KEY = 'language';
export const LANGUAGE_UA = 'ua';

export const FORM_ID = 'digest-subscribe';

const constants = {
  ANIMATION_DURATION,
  CLASS_BODY_HIDDEN,
  CLASS_MENU_VISIBLE,
  CLASS_MENU_BTN_CLOSE,
  DATA_TRANSLATE_MENU_OPEN,
  DATA_TRANSLATE_MENU_CLOSE,
  LOCAL_STORAGE_LANGUAGE_KEY,
  LANGUAGE_UA,
  CLASS_LANGUAGE_SELECTOR,
  CLASS_LANGUAGE_SELECTOR_BUTTON,
  CLASS_LANGUAGE_SELECTOR_BUTTON_HIDDEN,
  CLASS_LANGUAGE_SELECTOR_BUTTON_DROPDOWN_VISIBLE,
  CLASS_LANGUAGE_SELECTOR_ITEM,
  CLASS_LANGUAGE_SELECTOR_DROPDOWN,
  CLASS_LANGUAGE_SELECTOR_DROPDOWN_VISIBLE,
  CLASS_MENU,
  CLASS_MENU_BTN,
  CLASS_HEADER_MAIN_PART,
  CLASS_HEADER_MAIN_PART_HIDDEN,
  CLASS_HEADER_BOTTOM_PART,
  CLASS_HEADER_BOTTOM_PART_HIDDEN,
  FORM_ID,
  CLASS_SCROLL_UP_BTN,
  CLASS_SCROLL_UP_BTN_VISIBLE,
  CLASS_HEADER,
};

export default constants;
